export function getAnimationOverrides() {
  return []
}

export function getNavigationStacks() {
  return []
}
